<template>
  <div class="announcement-bar">
    <div class="announcement-content">
      <div class="announcement-container">
        <div class="user-info" v-if="user">
          <span class="nickname">Hi，亲爱的 {{ user.nick }}</span>
          <div class="logout-container">
            <button class="logout-btn" @click="logout">退出</button>
          </div>
        </div>
        <div @click="goToHome" class="version-container">
          {{ latestAnnouncement.version }}
        </div>
        <el-button class="nav-btn" type="primary" @click="goToHome">首页</el-button>
        <div class="announcement-content" @click="showAllAnnouncements">
          <div class="announcement-title">{{ latestAnnouncement.title }}</div>
          <div class="announcement-desc">{{ latestAnnouncement.content }}</div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="modal" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>公告详情</h3>
          <button @click="closeModal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="history-list">
            <div v-for="(item, index) in announcements" :key="index" class="history-item">
              <div class="history-version">{{ item.version }}</div>
              <div class="history-content">
                <div class="history-title">{{ item.title }}</div>
                <div class="history-desc">{{ item.content }}</div>
                <div class="history-date">{{ item.date }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnnouncementBar',
  data() {
    return {
      user: JSON.parse(localStorage.getItem('auth-user') || 'null'),
      announcements: [
        {
          version: 'v1.2.5',
          title: '增加香奈儿C2B淘宝快捷转换',
          content: `
          1、增加香奈儿C2B淘宝转换工具
          2、优化了部分UI
          3、🪿
         `,
          date: '2026-02-1'
        },
        {
          version: 'v1.2.4',
          title: '增加云片短链生成',
          content: `
          1、云片短链生成工具
          2、优化toekn验证逻辑，防止过期未及时刷新
          3、🪿
         `,
          date: '2026-01-23'
        },
        {
          version: 'v1.2.3',
          title: '优化校验规则',
          content: `
          1、dataworkssql查询过滤条件判断优化
          2、🪿
         `,
          date: '2026-01-14'
        },
        {
          version: 'v1.2.2',
          title: '优化使用体验',
          content: `
          1、sql编辑窗口支持拖动调衡展示区域
          2、原始数据查询支持缓存上一次记录
          3、🪿
         `,
          date: '2025-12-03'
        },
        {
          version: 'v1.2.1',
          title: '增加两个内部工具',
          content: `
          1、增加原始埋点数据查询
          2、增加授权指南，暂时只有京东
          3、🪿
         `,
          date: '2025-11-28'
        },
        {
          version: 'v1.2.0',
          title: '提供1.2版本，优化UI，导航栏',
          content: `
          1、优化UI
          2、移除左侧导航栏，顶部导航栏支持返回首页，点击版本号即可
          3、增加工具合集页面，将功能主要放在首页
          4、🪿
         `,
          date: '2025-09-24'
        },
        {
          version: 'v1.1.1',
          title: 'Api管理模块增加接口调试功能，优化json响应展示',
          content: `
          Api管理模块增加接口调试功能
          2、优化接口调试json响应展示
          3、优化appKey申请临时Token，json响应展示
          4、🪿
         `,
          date: '2025-07-23'
        },
        {
          version: 'v1.1.0',
          title: '增加登录模块相关',
          content: `
          1、增加登录
          2、，增加路由守卫
          3、移除旧的Appkey等。通过登录控制获取
          4、🪿
         `,
          date: '2025-05-26'
        },
        {
          version: 'v1.0.9',
          title: '增加转发Api模块',
          content: `
          1、转发Api功能支持
          2、，appKey管理支持
          3、支持一键复制请求参数、临时申请appKey请求Header
          4、🪿
         `,
          date: '2025-05-22'
        },
        {
          version: 'v1.0.8',
          title: '修复渠道流量导出SSE接口异常，重新实现UI，渠道路由合并',
          content: `
          1、修复渠道流量导出SSE接口异常
          2、，重新实现UI
          3、导出支持渠道可选
          4、移除无用路由
          5、🪿
         `,
          date: '2025-05-20'
        },
        {
          version: 'v1.0.7',
          title: '增加周期任务配置模块',
          content: `
          1、周期任务配置
          2、支持多个任务类型配置
          3、模板类型与模板列表打通
          4、增加克隆功能，快速克隆大致参数相同的任务
         `,
          date: '2025-05-15'
        },
        {
          version: 'v1.0.6',
          title: '增加合并报表、P2P文件互传等功能',
          content: `
          1、自定义模板报表增加合并报表，支持多个日报合并推送处理。
          2、优化上次报表链接下载逻辑优化，单机复制链接到剪切板，双击快速下载报表。
          3、优化UI布局，增加不同分辨率的自适应显示。
          4、合并报表公告支持sheet的动态拖动调整顺序
          5、增加P2P文件互传功能，支持文件互传，支持聊天室，只支持同一局域网内互传。
          6、增加公告栏，支持公告栏推送，支持公告栏历史记录查看。
          7、合并报表支持编辑功能。
         `,
          date: '2025-05-10'
        },
        {
          version: 'v1.0.5',
          title: '增加当日渠道流量查询',
          content: `
          1、支持今日查：延迟15分钟
          2、支持实时查询：延迟0-3分钟
         `,
          date: '2025-04-01'
        },
        {
          version: 'v1.0.4',
          title: '增加当日模板转换工具',
          content: `
          用来转换日报的模板报表：
          1、支持模板下载
          2、支持模板转换`,
          date: '2025-03-01'
        },
        {
          version: 'v1.0.3',
          title: '增加淘宝短链转换',
          content: `
          增加淘宝短链转换功能，支持批量转换.
          session联系阿伟获取`,
          date: '2025-03-01'
        },
        {
          version: 'v1.0.2',
          title: '优化',
          content: `
          增加了部分优化～～
          `,
          date: '2025-03-01'
        },
        {
          version: 'v1.0.1',
          title: '增加渠道流量导出',
          content: `
          增加渠道流量导出功能,支持按日期范围导出
          `,
          date: '2025-02-01'
        },
        {
          version: 'v1.0.0',
          title: '欢迎使用模板报表推送',
          content: `
          报表推送功能已上线，支持手动推送
          `,
          date: '2025-01-01'
        }
      ],
      showModal: false,
      currentAnnouncement: null
    }
  },
  computed: {
    latestAnnouncement() {
      return this.announcements[0]
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('auth-token')
      localStorage.removeItem('auth-user')
      this.$router.push('/login')
    },
    showAllAnnouncements() {
      this.showModal = true
      document.addEventListener('keydown', this.handleKeyDown)
    },
    closeModal() {
      this.showModal = false
      document.removeEventListener('keydown', this.handleKeyDown)
    },
    handleKeyDown(e) {
      if (e.key === 'Escape') {
        this.closeModal()
      }
    },
    beforeUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown)
    }
  }
}
</script>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goToHome = () => {
  // 跳转方式一：根据 path
  router.push('/')

  // 跳转方式二：根据 name
  // router.push({ name: 'tools-translate-template' })
}
</script>

<style scoped>
.announcement-bar {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.user-info {
  position: absolute;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: visible;
  padding-bottom: 5px;
}

.nickname {
  color: #1890ff;
  font-weight: bold;
  cursor: pointer;
  padding: 5px 20px;
  font-size: 14px;
  margin-right: 30px;
  position: relative;
  z-index: 1;
}

.logout-container {
  width: 100%;
  max-height: 0;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
  position: absolute;
  top: 100%;
}

.user-info:hover .logout-container,
.logout-container:hover {
  max-height: 40px;
}

.logout-btn {
  background: #4c68f0;
  color: white;
  border: none;
  padding: 5px 20px;
  border-radius: 0 0 4px 4px;
  cursor: pointer;
  font-size: 14px;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
}

.announcement-container {
  display: flex;
  width: 100%;
  max-width: 100%;
  padding: 10px 20px;
  align-items: center;
  margin: 0 auto;
}

.version-container {
  font-weight: bold;
  color: #1890ff;
  width: 100px;
  flex-shrink: 0;
  font-size: 16px;
  padding-right: 15px;
}

.version-container:hover {
  color: #0270d7;
}

.announcement-content {
  flex: 1;
  cursor: pointer;
  padding-left: 15px;
  padding-right: 20px;
  overflow: hidden;
}

.announcement-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.announcement-desc {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  padding-right: 80px;
}

.announcement-desc::after {
  content: "查看详情";
  position: absolute;
  right: 10;
  top: 0;
  background: #1890ff;
  color: white;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 12px;
}

.announcement-detail {
  width: 100%;
  padding: 10px;
}

.detail-row {
  margin-bottom: 10px;
  display: flex;
}

.detail-label {
  font-weight: bold;
  min-width: 60px;
}

.detail-value {
  flex: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 400px;
  padding-right: 10px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  max-width: 500px;
  width: 80%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.modal-body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 10px;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.history-item {
  display: flex;
  gap: 15px;
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.history-version {
  font-weight: bold;
  color: #1890ff;
  width: 80px;
  flex-shrink: 0;
}

.history-content {
  flex: 1;
}

.history-title {
  font-weight: bold;
  margin-bottom: 5px;
  text-align: center;
}

.history-desc {
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
}

.history-date {
  color: #999;
  font-size: 12px;
  text-align: right;
}

.nav-btn {
  font-size: 16px;
  font-weight: 500;
  padding: 0 20px;
  height: 50px;
  border-radius: 0;
  /* 去掉圆角，更像导航 */
  border: none;
  /* 去掉边框 */
  background: transparent;
  /* 默认透明背景 */
  color: #409eff;
  /* 默认字体颜色 */
}

.nav-btn:hover {
  background: rgba(64, 158, 255, 0.1);
  /* hover 时淡蓝背景 */
  color: #0579ee;
  /* hover 字体高亮 */
}
</style>
